const appId = process.env.REACT_APP_APP_ID || 'APP_OVI';
const regionId = process.env.REACT_APP_REGION_ID || 'IN';

const LocalStorageKeys = Object.freeze({
  USER_DETAILS: `${appId}_${regionId}_userDetails`,
  USER_TOKEN: `${appId}_${regionId}_userToken`,
  SESSION_EXPIRATION: `${appId}_${regionId}_sessionExpiration`,
  SEARCH_DATA: `${appId}_${regionId}_searchData`,
});


class LocalStorageService {
  static get(key) {
    try {
      const value = window.localStorage.getItem(key);
      if (value === null) return null;
      
      // Automatically parse JSON if possible, fallback to string if not
      try {
        return JSON.parse(value);
      } catch {
        return value; 
      }
    } catch (error) {
      console.warn('LocalStorageService.get failed.', error);
      return null;
    }
  }

  static set(key, value) {
    try {
      // Automatically stringify objects/arrays
      const serializedValue = typeof value === 'object' ? JSON.stringify(value) : String(value);
      window.localStorage.setItem(key, serializedValue);
    } catch (error) {
      console.warn('LocalStorageService.set failed.', error);
    }
  }

  static remove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.warn('LocalStorageService.remove failed.', error);
    }
  }

  /**
   * Safely clears ONLY the keys explicitly defined in LocalStorageKeys.
   */
  static clear() {
    try {
      // Object.values gives us an array of the actual string keys: 
      // ['APP_OVI_IN_userDetails', 'APP_OVI_IN_userToken', ...]
      Object.values(LocalStorageKeys).forEach(key => {
        window.localStorage.removeItem(key);
      });
    } catch (error) {
      console.warn('LocalStorageService.clear failed.', error);
    }
  }
}

export { LocalStorageKeys, LocalStorageService };